export const isManageSilenceSubmitDisabled = (
    formTimeValue: string | number
) => {
    return typeof formTimeValue === "string"
}
